import React from 'react';
import { Modal, View, Text, TouchableOpacity, StyleSheet, Image } from 'react-native';
import { Colors } from '../../../styles';
import DiscountSvg from './svg/DiscountSvg';

const FractionInfo = ({ isVisible, closeModal }) => {
  return (
    <Modal
      animationType='fade'
      transparent={true}
      visible={isVisible}
      onRequestClose={() => closeModal()}
    >
      <View style={styles.modalContainer}>
        <View style={styles.slide}>
          <TouchableOpacity style={styles.closeButton} onPress={() => closeModal()}>
            <Text style={styles.closeButtonText}>Fechar</Text>
          </TouchableOpacity>
          <DiscountSvg width={250} height={150} />
          <Text style={styles.modalText}>
            {"É uma empresa e quer dar desconto aos seus clientes? Então use as frações!\nCom ela você fraciona os seus creditos em valores menores e com eles aplicar desconto nos tickets dos seus clientes.\nÉ possível compartilhar essa fração com seus colaboradores para agilizar o trabalho."}
          </Text>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  wrapper: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  slide: {
    // flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Colors.WHITE,
    padding: 20,
    borderRadius: 10,
  },
  closeButton: {
    alignSelf: 'flex-end',
    padding: 10,
  },
  closeButtonText: {
    color: 'blue',
    fontWeight: 'bold',
  },
  svgContainer: {
    marginVertical: 20,
  },
  modalText: {
    textAlign: 'center',
    fontSize: 16,
    marginTop: 24,
  },
});

export default FractionInfo;
